(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ah-editorial-product-info"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ah-product-tabs')) {
    customElements.define('ah-product-tabs', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const form = document.getElementById(this.getAttribute('form-id'));
        form?.addEventListener('variant:change', event => {
          const variant = event.detail?.variant;
          if (!variant) return;
          this.querySelectorAll('[data-ah-dispatch-variants]').forEach(element => {
            element.hidden = !element.dataset.ahDispatchVariants.split(',').includes(String(variant.id));
          });
          this.querySelectorAll('[data-ah-variant-color]').forEach(element => {
            element.hidden = !variant.options.includes(element.dataset.ahVariantColor);
          });
          const white = variant.options.includes(this.dataset.primaryColor || 'White');
          this.querySelectorAll('[data-ah-copy]').forEach(element => {
            element.hidden = element.dataset.ahCopy === 'white' ? !white : white;
          });
        }, {signal: this.abort.signal});
        const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        const activate = tab => {
          for (const item of tabs) {
            const selected = item === tab;
            item.setAttribute('aria-selected', String(selected));
            item.tabIndex = selected ? 0 : -1;
            this.querySelector('#' + CSS.escape(item.getAttribute('aria-controls'))).hidden = !selected;
          }
        };
        for (const tab of tabs) {
          tab.addEventListener('click', () => activate(tab), {signal: this.abort.signal});
          tab.addEventListener('keydown', event => {
            let index = tabs.indexOf(tab);
            if (event.key === 'ArrowRight') index = (index + 1) % tabs.length;
            else if (event.key === 'ArrowLeft') index = (index - 1 + tabs.length) % tabs.length;
            else if (event.key === 'Home') index = 0;
            else if (event.key === 'End') index = tabs.length - 1;
            else return;
            event.preventDefault();
            activate(tabs[index]);
            tabs[index].focus();
          }, {signal: this.abort.signal});
        }
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ah-editorial-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ah-stringata-title')) {
    customElements.define('ah-stringata-title', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        document.addEventListener('variant:change', event => {
          if (event.target.getAttribute('id') !== this.getAttribute('form-id')) return;
          const colors = event.detail?.variant?.options;
          if (!colors) return;
          if (colors.includes('LIGHT BLUE')) {
            this.textContent = this.getAttribute('blue-title');
          } else if (colors.includes('White')) {
            this.textContent = this.getAttribute('white-title');
          }
        }, {signal: this.abort.signal});
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ah-editorial-shirt-suggestions"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ah-cross-sell')) {
  customElements.define('ah-cross-sell', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const info = this.closest('.product-info');
      const form = document.getElementById(info?.querySelector('ah-product-tabs')?.getAttribute('form-id')) || info?.querySelector('form[action*="/cart/add"]');
      const update = event => {
        const options = event.detail?.variant?.options;
        if (!options) return;
        const color = this.dataset.colors.split('|').find(value => options.includes(value)) || '*';
        this.querySelectorAll('[data-pairing-color]').forEach(group => {
          group.hidden = group.dataset.pairingColor !== color;
        });
      };
      (form || document).addEventListener('variant:change', update, {signal: this.abort.signal});
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ah-fit-summary"] && !Shopify.designMode) return;
  try {
    document.addEventListener('variant:change', event => {
    const variantId = event.detail?.variant?.id;
    if (!variantId) return;
    document.querySelectorAll('[data-ah-mesh-model]').forEach(model => {
      const picker = model.closest('variant-picker');
      if (picker?.getAttribute('form-id') !== event.target.id) return;
      model.hidden = model.dataset.ahMeshModel !== String(variantId);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ah-product-controller"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ah-product-controller')) {
    customElements.define('ah-product-controller', class extends HTMLElement {
      static confirmedForms = new Set();

      connectedCallback() {
        if (!this.isConnected || !document.body) return;
        const formId = this.getAttribute('form-id');
        this.formId = formId;
        if (!this.form) return;
        this.abort = new AbortController();
        this.confirmed = this.constructor.confirmedForms.has(formId);
        this.pending = false;
        const options = {signal: this.abort.signal};
        document.addEventListener('submit', event => {
          if (event.target.getAttribute('id') !== this.formId) return;
          if (this.sizeGroup && (!this.confirmed || this.pending)) {
            event.preventDefault();
            event.stopImmediatePropagation();
            const message = this.sizeGroup.querySelector('[data-ah-size-message]');
            if (message) message.hidden = false;
            this.sizeGroup.scrollIntoView({behavior: 'smooth', block: 'center'});
            this.sizeGroup.querySelector('input[type="radio"]')?.focus({preventScroll: true});
          }
        }, {...options, capture: true});
        document.addEventListener('change', event => {
          const input = event.target;
          if (!(input instanceof HTMLInputElement) || input.getAttribute('form') !== this.formId || !input.hasAttribute('data-option-position')) return;
          clearTimeout(this.restoreTimer);
          clearInterval(this.restorePoll);
          if (input.closest('[data-ah-size-choice]')) {
            this.confirmed = true;
            this.constructor.confirmedForms.add(this.getAttribute('form-id'));
          } else if (this.sizeGroup) {
            this.resetAfterColor = true;
          }
          this.pending = true;
          this.sync();
        }, {...options, capture: true});
        document.addEventListener('product:rerender', event => {
          if (event.target.getAttribute('id') !== this.formId) return;
          event.target.addEventListener('variant:change', () => {
          if (this.resetAfterColor) {
            this.confirmed = false;
            this.constructor.confirmedForms.delete(this.getAttribute('form-id'));
            this.resetAfterColor = false;
          }
          this.pending = false;
          this.sync();
          }, {once: true, signal: this.abort.signal});
        }, {...options, capture: true});
        const restoreSelection = () => {
          const picker = this.sizeGroup?.closest('variant-picker');
          if (picker?.getAttribute('handle') !== 'cappotto-oversize') return;
          clearTimeout(this.restoreTimer);
          clearInterval(this.restorePoll);
          let attempts = 0;
          const reconcile = () => {
            if (!this.isConnected || this.confirmed || this.pending || ++attempts > 30) {
              clearInterval(this.restorePoll);
              return;
            }
            if (this.sizeGroup?.querySelector('input[type="radio"]:checked')) {
              clearInterval(this.restorePoll);
              this.restoreSizeSelection();
            }
          };
          this.restoreTimer = setTimeout(reconcile, 0);
          this.restorePoll = setInterval(reconcile, 100);
        };
        window.addEventListener('pageshow', restoreSelection, options);
        window.addEventListener('pagehide', () => {
          clearTimeout(this.restoreTimer);
          clearInterval(this.restorePoll);
        }, options);
        this.sync();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', restoreSelection, {...options, once: true});
        } else {
          restoreSelection();
        }
      }

      disconnectedCallback() {
        this.abort?.abort();
        clearTimeout(this.restoreTimer);
        clearInterval(this.restorePoll);
      }

      restoreSizeSelection() {
        if (!this.isConnected || !this.form || !this.sizeGroup) return;
        const selectedSize = this.sizeGroup.querySelector('input[type="radio"]:checked');
        if (!selectedSize) {
          this.confirmed = false;
          this.pending = false;
          this.constructor.confirmedForms.delete(this.formId);
          this.sync();
          return;
        }
        const picker = this.sizeGroup.closest('variant-picker');
        const optionValues = Array.from(this.form.elements)
          .filter(input => input.matches('input[data-option-position]:checked'))
          .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
          .map(input => input.value);
        this.confirmed = true;
        this.constructor.confirmedForms.add(this.formId);
        this.resetAfterColor = false;
        this.pending = true;
        this.sync();
        picker.selectCombination({optionValues, productChange: false}).catch(() => {
          if (!this.isConnected) return;
          this.confirmed = false;
          this.pending = false;
          this.constructor.confirmedForms.delete(this.formId);
          this.sync();
        });
      }

      get form() {
        return document.getElementById(this.formId);
      }

      get sizeGroup() {
        return document.querySelector('variant-picker[form-id="' + CSS.escape(this.getAttribute('form-id')) + '"] [data-ah-size-choice]');
      }

      sync() {
        const group = this.sizeGroup;
        if (!group) return;
        group.dataset.ahSizeConfirmed = String(this.confirmed);
        if (!this.confirmed) group.querySelectorAll('input[type="radio"]').forEach(input => { input.checked = false; });
        const message = group.querySelector('[data-ah-size-message]');
        if (message && this.confirmed) message.hidden = true;
        document.querySelectorAll('buy-buttons[form="' + CSS.escape(this.getAttribute('form-id')) + '"] button[type="submit"]').forEach(button => {
          if (!button.dataset.ahOriginalLabel) {
            button.dataset.ahOriginalLabel = button.textContent.trim();
            button.dataset.ahOriginalDisabled = String(button.disabled);
          }
          button.textContent = this.confirmed ? button.dataset.ahOriginalLabel : this.getAttribute('choose-label');
          button.disabled = this.pending || (this.confirmed && button.dataset.ahOriginalDisabled === 'true');
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ah-stock-notification"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ah-stock-notification')) {
    customElements.define('ah-stock-notification', class extends HTMLElement {
      connectedCallback() {
        if (!this.isConnected || !document.body) return;
        this.form = document.getElementById(this.getAttribute('form-id'));
        if (!this.form) return;
        this.variants = JSON.parse(this.querySelector('script').textContent);
        this.abort = new AbortController();
        this.schedule = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); });
        };
        this.form.addEventListener('variant:change', event => {
          this.currentVariant = event.detail?.variant;
          this.variantPending = false;
          this.schedule();
        }, {signal: this.abort.signal});
        document.addEventListener('change', event => {
          if (event.target.form === this.form && event.target.hasAttribute('data-option-position')) this.variantPending = true;
          this.schedule();
        }, {signal: this.abort.signal});
        this.observer = new MutationObserver(this.schedule);
        this.observer.observe(document.body, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['data-variant-id', 'data-ah-size-confirmed']});
        this.sync();
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      sync() {
        const id = this.form.elements.namedItem('id')?.value;
        const variant = this.currentVariant && String(this.currentVariant.id) === String(id) ? this.currentVariant : this.variants.find(item => String(item.id) === String(id));
        const group = document.querySelector('variant-picker[form-id="' + CSS.escape(this.getAttribute('form-id')) + '"] [data-ah-size-choice]');
        document.querySelectorAll('.gw-button-widget[data-product-id="' + this.getAttribute('product-id') + '"], .gw-float-widget[data-product-id="' + this.getAttribute('product-id') + '"]').forEach(button => {
          const widgetVariant = button.dataset.variantId;
          const mismatch = widgetVariant && String(widgetVariant) !== String(id);
          const sizePending = group && group.dataset.ahSizeConfirmed === 'false';
          button.dataset.ahHidden = String(!variant || variant.available || Boolean(mismatch) || Boolean(sizePending) || Boolean(this.variantPending));
          if ((button.tagName === 'BUTTON' || button.childElementCount === 0) && button.textContent.trim() !== this.getAttribute('label')) button.textContent = this.getAttribute('label');
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
